"use client";

import ReactDOM from "react-dom";

export function PreloadResources() {
  // DNS Prefetch and Preconnect
  ReactDOM.prefetchDNS("https://d3ow7eryaiv10m.cloudfront.net");
  ReactDOM.preconnect("https://d3ow7eryaiv10m.cloudfront.net", {
    crossOrigin: "anonymous",
  });

  // Fabriga
  ReactDOM.preload(
    "https://d3ow7eryaiv10m.cloudfront.net/fonts/Fabriga-Medium.otf",
    {
      as: "font",
      type: "font/otf",
      crossOrigin: "anonymous",
    },
  );
  ReactDOM.preload(
    "https://d3ow7eryaiv10m.cloudfront.net/fonts/Fabriga-Bold.otf",
    {
      as: "font",
      type: "font/otf",
      crossOrigin: "anonymous",
    },
  );

  // Fraunces
  ReactDOM.preload(
    "https://d3ow7eryaiv10m.cloudfront.net/fonts/Fraunces[SOFT,WONK,opsz,wght].woff2",
    {
      as: "font",
      type: "font/woff2",
      crossOrigin: "anonymous",
    },
  );
  ReactDOM.preload(
    "https://d3ow7eryaiv10m.cloudfront.net/fonts/Fraunces-Italic[SOFT,WONK,opsz,wght].woff2",
    {
      as: "font",
      type: "font/woff2",
      crossOrigin: "anonymous",
    },
  );

  // DM Sans
  ReactDOM.preload(
    "https://d3ow7eryaiv10m.cloudfront.net/fonts/DMSans-Regular.ttf",
    {
      as: "font",
      type: "font/ttf",
      crossOrigin: "anonymous",
    },
  );
  ReactDOM.preload(
    "https://d3ow7eryaiv10m.cloudfront.net/fonts/DMSans-Medium.ttf",
    {
      as: "font",
      type: "font/ttf",
      crossOrigin: "anonymous",
    },
  );
  ReactDOM.preload(
    "https://d3ow7eryaiv10m.cloudfront.net/fonts/DMSans-SemiBold.ttf",
    {
      as: "font",
      type: "font/ttf",
      crossOrigin: "anonymous",
    },
  );
  ReactDOM.preload(
    "https://d3ow7eryaiv10m.cloudfront.net/fonts/DMSans-Bold.ttf",
    {
      as: "font",
      type: "font/ttf",
      crossOrigin: "anonymous",
    },
  );

  return null;
}
